import { TextField } from "@mui/material";

const NumberComponent = (props) => {
  const { question } = props;
  return (
    <>
        <TextField
        id={question._id}
        fullWidth={true} 
        type="number"
        placeholder={question.tooltip ? question.questiond.tooltip : ""}
        onChange={(event) => {}}
        variant="outlined"
      />
      {question?.questiond?.helpPage !== undefined && (
        <a href="#">
          <div style={{ width: "100%", textAlign: "right" }}>
            {question.helpText}
          </div>
        </a>
      )}
    </>
  );
};
export default NumberComponent;
